import React from 'react';
import styled from 'styled-components';
import { useAppContext } from '../context/AppContext';
import { Container, SectionShell, text } from '../styles/GlobalStyles';
import SectionHeader from './common/SectionHeader';
import Reveal from './common/Reveal';

// Two by two: each category keeps enough width for its own two-column list.
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const Column = styled.div`
  padding: 28px 32px 20px 0;
  border-top: 1px solid ${props => props.theme.colors.border};

  &:nth-child(even) {
    padding: 28px 0 20px 32px;
    border-left: 1px solid ${props => props.theme.colors.border};
  }

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    &,
    &:nth-child(even) {
      padding: 28px 0 8px;
      border-left: none;
    }
  }
`;

const Head = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;

  h3 {
    font-size: ${text.base};
    font-weight: 600;
    letter-spacing: -0.01em;
    color: ${props => props.theme.colors.text};
  }

  span {
    font-size: ${text.xs};
    font-variant-numeric: tabular-nums;
    color: ${props => props.theme.colors.textTertiary};
  }
`;

const Items = styled.ul`
  list-style: none;
  columns: 2;
  column-gap: 24px;

  li {
    break-inside: avoid;
    padding: 5px 0;
    font-size: ${text.sm};
    color: ${props => props.theme.colors.textSecondary};
  }
`;

const Skills: React.FC = () => {
  const { content } = useAppContext();
  const { skills } = content;

  return (
    <SectionShell id="skills">
      <Container>
        <SectionHeader index={3} title={skills.title} />

        <Reveal>
          <Grid>
            {skills.categories.map(category => (
              <Column key={category.name}>
                <Head>
                  <h3>{category.name}</h3>
                  <span>{category.items.length}</span>
                </Head>
                <Items>
                  {category.items.map(skill => (
                    <li key={skill}>{skill}</li>
                  ))}
                </Items>
              </Column>
            ))}
          </Grid>
        </Reveal>
      </Container>
    </SectionShell>
  );
};

export default Skills;
